/* jt-parcelpanel-seo */
(function () {
  var path = (window.location && window.location.pathname) || '';
  if (!/parcelpanel/i.test(path)) return;
  var loc = String((window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase().split('-')[0];
  var titles = {"de":"Bestellung verfolgen – JT-Products | Performance Auto Teile","fr":"Suivre la commande – JT-Products | Pièces auto performance","en":"Track your order – JT-Products | Performance Car Parts","it":"Segui l'ordine – JT-Products | Componenti auto performance","es":"Seguir pedido – JT-Products | Piezas de rendimiento","pl":"Śledź zamówienie – JT-Products | Części performance","pt":"Seguir encomenda – JT-Products | Peças de performance","nl":"Bestelling volgen – JT-Products | Performance Auto Onderdelen"};
  var t = titles[loc] || titles.nl;
  function apply() {
    try { if (document.title !== t) document.title = t; } catch (e) {}
    document.querySelectorAll('h1,h2,.pp-title,[class*="title"]').forEach(function (el) {
      var txt = (el.textContent || '').trim();
      if (/Bestelling volgen/i.test(txt)) el.textContent = t.split('–')[0].trim();
    });
  }
  apply();
  [200,800,2000,5000].forEach(function (ms) { setTimeout(apply, ms); });
})();
/* jt-parcelpanel-seo-bust:1785232609515 */
